import Immutable from 'immutable';
import { GET_INSURANCES } from '../constants';

const INITIAL_STATE = Immutable.fromJS({insurances: [], insurancesCount: 0});

export default function (state = INITIAL_STATE, action)
{
	let nextState = state.toJS();

	switch (action.type) {
		case GET_INSURANCES:
            nextState.insurances = action.payload.rows
            nextState.insurancesCount = action.payload.count
        break;
        default:

        break;
	}

	return state.merge(nextState);
}
